import styled from 'styled-components'
import { createTokenKey, selectToken } from '@caudena/web-platform'
export const GlobalSearchBody = styled.div`
  padding: ${({ theme }) =>
    `0 ${selectToken(theme, createTokenKey(['padding', 'lg']))}`};
`
